export const ENABLE_DELIVERY = 'enable_delivery';

export const flags = {
  [ENABLE_DELIVERY]: flags => {
    return true;
  }
};
